import { Yup, type YupTypes } from "@pharmupp/p3-front-commons"

export enum AssignmentEnum {
  UPP_ID = "uppId",
  SECTOR_ID = "sectorId",
  ULTRA = "ultra",
  ENTRY_DATE = "entryDate",
  CERP_CODE = "cerpCode",
  CERP_BRANCH = "cerpBranch",
  NEGATIVE_SEGMENTATION = "negativeSegmentation",
}

export const assignmentSchema = Yup.object({
  [AssignmentEnum.UPP_ID]: Yup.number().required("L'UPP de rattachement est requis"),
  [AssignmentEnum.SECTOR_ID]: Yup.number().required("Le secteur est requis"),
  [AssignmentEnum.ULTRA]: Yup.boolean().required(),
  [AssignmentEnum.ENTRY_DATE]: Yup.date().required(
    "La date d'ancienneté est requise",
  ),
  [AssignmentEnum.CERP_CODE]: Yup.string()
    .required("Le code CERP est requis")
    .matches(/^\d{5}/g, "Le code CERP est invalide"),
  [AssignmentEnum.CERP_BRANCH]: Yup.object({
    code: Yup.string().required("L'établissement CERP est requis"),
  }).required("L'établissement CERP est requis"),
  [AssignmentEnum.NEGATIVE_SEGMENTATION]: Yup.boolean().required(),
})

export type AssignmentFormValues = YupTypes.InferType<typeof assignmentSchema>
